import React, { useEffect, useState } from "react"
import { Box, Grid, InputAdornment, styled, TextField } from "@mui/material"
import Header from "components/Header/Header"
import { createBreadcrumbs } from "helpers/breadCrumbs"
import styles from "../groupLeaderBoard.module.scss"
import AppButton from "components/StyledComponents/AppButton"
import SearchIcon from "assets/icons/Search.svg"
import { useDispatch, useSelector } from "react-redux"
import { getRestaurantGroupAction } from "redux/DMV/actions/user"
import GroupLeaderBoardTable from "./groupLeaderboardTable"
import { useDebounce } from "hooks/utils"
import AppPagination from "components/StyledComponents/AppPagination"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"

const CustomSearchField = styled(TextField)(() => ({
  background: "#000",
  borderRadius: 8
}))

const GroupLeaderBoard = () => {
  const [breadCrumbs, setBreadcrumbs] = useState([])
  const [searchValue, setSearchValue] = useState("")
  const [groupLeaderboardList, setGroupLeaderboardList] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [pages, setPages] = useState(1)
  const dispatch = useDispatch()
  const history = useHistory()
  const { groupLeaderboardData } = useSelector((store) => store?.dmv)
  const debouncedSearchTerm = useDebounce(searchValue, 500)

  const handleSearchField = (e) => {
    setSearchValue(e.target.value)
  }

  function filterResults(results, searchTerm) {
    let filteredResults = results
    if (searchTerm.trim() === "") return results

    const searchRegex = new RegExp(searchTerm.trim().replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "i")

    filteredResults = filteredResults?.filter((item) => searchRegex.test(item.name))

    return filteredResults
  }

  useEffect(() => {
    const filteredResults = filterResults(groupLeaderboardData, debouncedSearchTerm)
    const itemsPerPage = 10
    const totalPages = Math.ceil(filteredResults?.length / itemsPerPage)
    const paginatedGroupLeaderboardList = filteredResults?.slice(
      (currentPage - 1) * itemsPerPage,
      currentPage * itemsPerPage
    )
    setGroupLeaderboardList(paginatedGroupLeaderboardList)
    setPages(totalPages)
  }, [debouncedSearchTerm, groupLeaderboardData, currentPage])

  useEffect(() => {
    setCurrentPage(1)
  }, [debouncedSearchTerm])

  useEffect(() => {
    document.title = "Group Leaderboard"
    dispatch(getRestaurantGroupAction({}))
    setBreadcrumbs(createBreadcrumbs())
  }, [])

  return (
    <Grid container>
      <Grid item xs={12}>
        <Header title={"Group Leaderboard"} breadCrumbs={breadCrumbs} />
      </Grid>
      <Grid item container xs={12} mt={4} className={styles.groupLeaderBoardContainer}>
        <Grid item container xs={12} justifyContent={"end"}>
          <Box className={styles.actionContainer}>
            <CustomSearchField
              type="search"
              autoComplete="off"
              value={searchValue}
              onChange={handleSearchField}
              placeholder="Search"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <img
                      src={SearchIcon}
                      style={{
                        cursor: "pointer",
                        fontSize: "30px"
                      }}
                    />
                  </InputAdornment>
                )
              }}
              fullWidth
            />
            <AppButton
              styles={{ padding: "10px 15px" }}
              onClick={() => {
                history.push("/dmv/dashboard/restaurants-group")
              }}>
              {" "}
              + Add New Group Leaderboard
            </AppButton>
          </Box>
        </Grid>
        <Grid container item xs={12} mt={4} className={styles.groupTableContainer}>
          <GroupLeaderBoardTable
            columns={columns}
            rows={groupLeaderboardList}
            currentPage={currentPage}
          />
        </Grid>
        <Grid item xs={12} justifyContent={"end"}>
          {groupLeaderboardData?.length ? (
            <AppPagination
              onPageChange={setCurrentPage}
              totalPages={pages}
              currentPage={currentPage}
            />
          ) : (
            ""
          )}
        </Grid>
      </Grid>
    </Grid>
  )
}

export default GroupLeaderBoard
const columns = [
  {
    id: "2",
    label: "Name",
    minWidth: 260,
    align: "left"
  },
  {
    id: "3",
    label: "Created On",
    minWidth: 400,
    align: "left"
  },
  {
    id: "4",
    label: "Action",
    minWidth: 300,
    align: "center"
  }
]
